import { withModuleContext } from "@edreamsodigeo/frontend-core";
import { PrismaProvider } from "@edreamsodigeo/prisma-design-system";

export const MODULE_NAMESPACE = "frontend-error-fallbacks";

export default withModuleContext({
  namespace: MODULE_NAMESPACE,
  PrismaProvider,
});
